// extracted by mini-css-extract-plugin
export var addButton = "_jr-0";
export var border = "_jr-8";
export var check = "_jr-h";
export var danger = "_jr-6";
export var dropdownContainer = "_jr-1";
export var editModalBody = "_jr-j";
export var footerContainer = "_jr-i";
export var fullWidth = "_jr-a";
export var hide = "_jr-9";
export var icon = "_jr-3";
export var input = "_jr-7";
export var inputFlex = "_jr-b";
export var inputWrapper = "_jr-c";
export var manualFocus = "_jr-5";
export var optionButton = "_jr-4";
export var pillWrapper = "_jr-e";
export var pointer = "_jr-2";
export var showOverflow = "_jr-f";
export var tagsFlex = "_jr-d";
export var xButton = "_jr-g";